import { Stack, Text } from "basis";

const genericErrorCodes = [
  "PHONE_NUMBER_COUNTRY_CODE_NOT_SUPPORTED",
  "PHONE_NUMBER_COUNTRY_CODE_NULL",
  "PHONE_NUMBER_FORMAT_ERROR",
  "CARD_ACTIVATION_LOCKED",
];

export const PERSONAL_LOAN_ERRORS = {
  ADDITIONAL_INFORMATION_REQUIRED:
    "More information required. Please provide your first name.",
};

const genericErrorContent = () => (
  <Stack gap="6" margin="0 0 6 0">
    <Text textStyle="heading4">Unable to link account</Text>
    <Text>
      We've been unable to link your account.
      <br /> Please check our FAQs or contact us to resolve.
    </Text>
  </Stack>
);

const specificErrors = [
  {
    type: "NO_MOBILE_NUMBER",
    content: () => (
      <Stack gap="6" margin="0 0 6 0">
        <Text textStyle="heading4">We need your mobile number</Text>
        <Text>
          We couldn't find any mobile number associated with this account which
          is needed for verification.
          <br />
          Please get in touch with us to fix this up.
        </Text>
      </Stack>
    ),
  },
];

export function getFatalErrorContent(e) {
  if (genericErrorCodes.some((type) => e.type === type)) {
    return genericErrorContent;
  }

  const specialError = specificErrors.find(({ type }) => e.type === type);

  return specialError ? specialError.content : null;
}
